export const fabrics = [
  {
    id: 1,
    title: "Yarn Dyed",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 2,
    title: "Chambray",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 3,
    title: "Dobby",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 4,
    title: "Double Cloth",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 5,
    title: "Printed",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 6,
    title: "Jacquard",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 7,
    title: "Swiss Dot",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 8,
    title: "Coated",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 9,
    title: "Twill & Drill",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 10,
    title: "Checks",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 11,
    title: "Stripes",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 12,
    title: "Slub",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 13,
    title: "Seer Sucker",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 14,
    title: "Flannel",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 15,
    title: "Crepe / Crinkle",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 16,
    title: "Waffle",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 17,
    title: "Poplin",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 18,
    title: "Polka Dot",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 19,
    title: "Muslin",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 20,
    title: "Rib Fabric",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 21,
    title: "Mesh / Net",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 22,
    title: "Gauze",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 23,
    title: "Greige",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 24,
    title: "Voile / Cambric",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
  {
    id: 25,
    title: "Slub Fabric",
    img: "https://img1.exportersindia.com/product_images/bc-full/2018/11/2439732/cotton-yarn-dyed-printed-fabric-1543396385-4508177.jpeg",
  },
];

export const sampleFabrics = [
  {
    id: 1,
    title: "Yarn Dyed",
    img: "https://rubyfabricslinings.com/wp-content/uploads/2021/01/yarn-dyed-check-fabric-rubyfabricslinings.com_.jpg",
  },
  {
    id: 2,
    title: "Chambray",
    img: "https://cdn.shopify.com/s/files/1/1116/5366/articles/Fabric_Type_-_1024_-_Chambray_1024x.jpg?v=1645616699",
  },
  {
    id: 3,
    title: "Dobby",
    img: "https://rubyfabricslinings.com/wp-content/uploads/2019/06/Unstitched-Digital-Printed-Polytwill-Fabric-Rubyfabricslinings.com_-570x489.jpg",
  },
  {
    id: 4,
    title: "Double Cloth",
    img: "https://img2.exportersindia.com/product_images/bc-full/dir_11/321096/double-cloth-291050.jpg",
  },
  {
    id: 5,
    title: "Printed",
    img: "https://img3.exportersindia.com/product_images/bc-full/2018/9/5863817/organic-cotton-printed-fabric-1535979699-4259673.jpeg",
  },
  {
    id: 6,
    title: "Seer Sucker",
    img: "https://pinecrestfabrics.com/wp-content/uploads/2018/10/Fabric-Sale-35.png",
  },
  {
    id: 7,
    title: "Crepe / Crinkle",
    img: "https://sc04.alicdn.com/kf/Hc75eed60fede4463a43dc7acbab264efM.jpg",
  },
  {
    id: 8,
    title: "Greige",
    img: "https://schotttextiles.com/wp-content/uploads/2016/01/articles_2.jpg",
  },
];

export const process = [
  {
    id: 1,
    img: "https://antimakhanna.com/wp-content/uploads/2021/03/ikat16.jpg",
    title: "Ikat dyeing process",
  },
  {
    id: 2,
    img: "https://i0.wp.com/assets-clothroads-com.s3.amazonaws.com/uploads/2013/09/Ikat_Print-India.jpg?ssl=1",
    title: "Ikat warping",
  },
  {
    id: 1,
    img: "https://www.dsource.in/sites/default/files/resource/ikat-saree-weaving-sambalpur-orissa/making-process/minigallery/18888/17.jpg",
    title: "Ikat weaving",
  },
];

export const design = [
  {
    id: 1,
    img: "../src/images/head.jpg",
  },
  {
    id: 2,
    img: "../src/images/design2.jpg",
  },
  {
    id: 3,
    img: "../src/images/design3.jpg",
  },
];
